import { css } from 'styled-system/css';
import { LogoMark } from '../../ui/logo/LogoMark';

export function PrismFab({ open = true }: { open?: boolean }) {
  return (
    <span
      data-open={open || undefined}
      className={css({
        position: 'absolute',
        right: '4',
        bottom: '4',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: 'full',
        borderTop: '1px solid white',
        color: '#000',
        backgroundImage:
          'linear-gradient(135deg, token(colors.prism.violet), token(colors.prism.mid), token(colors.prism.green))',
        boxShadow: 'md',
        zIndex: 1,
        transformOrigin: 'center',
        transform: 'scale(0)',
        opacity: 0,
        filter: 'blur(2px)',
        transition:
          'transform 180ms cubic-bezier(0.4, 0, 0.2, 1), opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), filter 180ms cubic-bezier(0.4, 0, 0.2, 1)',
        willChange: 'transform, opacity, filter',
        _motionReduce: { transition: 'none' },
        '&[data-open]': {
          transform: 'scale(1)',
          opacity: 1,
          filter: 'blur(0)',
          transition:
            'transform 500ms cubic-bezier(0.34, 1.36, 0.64, 1), opacity 400ms cubic-bezier(0.34, 1.36, 0.64, 1), filter 500ms cubic-bezier(0.34, 1.36, 0.64, 1)',
        },
      })}
    >
      <LogoMark size={18} />
    </span>
  );
}
